import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IconComponent } from '../icon/icon.component'

@Component({
  selector: 'hyperkit-code-block',
  templateUrl: './code-block.component.html',
  styleUrls: ['./code-block.component.scss'],
  standalone: true,
  imports: [IconComponent],
})
export class CodeBlockComponent {
  @Input() code = ''
  @Input() copyable = false
  @Output() copied = new EventEmitter<string>()
}
